<template>
  <div :id="id"></div>
</template>

<script>
import E from "wangeditor";
import axios from "axios";

const { $, PanelMenu, Panel } = E;

function getRandom(prefix) {
  return prefix + Math.random().toString().slice(2);
}

function getCookie(cookie_name) {
  var allcookies = document.cookie;
  var cookie_pos = allcookies.indexOf(cookie_name);
  if (cookie_pos !== -1) {
    cookie_pos = cookie_pos + cookie_name.length + 1;
    var cookie_end = allcookies.indexOf(";", cookie_pos);
    if (cookie_end === -1) {
      cookie_end = allcookies.length;
    }
    var value = unescape(allcookies.substring(cookie_pos, cookie_end));
  }
  return value;
}

function createPanelConf(editor) {
  // panel 中需要用到的id
  const inputIFrameId = getRandom("input-iframe");
  // const inputVideoId = getRandom("inputVideoId");
  const btnOkId = getRandom("btn-ok");
  const upTriggerVideoId = getRandom("up-trigger-video");
  const upFileVideoId = getRandom("up-file-video");
  // var uploadImg = editor.uploadImg;
  /**
   * 插入链接
   * @param video html标签
   */
  function upLoadVide(resultFiles, insertVideo) {
    const isLtxM = resultFiles[0].size / 1024 / 1024 < 10;
    if (!isLtxM){
      alert('上传文件大小不能超过 10MB，请删除该文件，重新上传!');
      return
    }
    const COS = require("cos-js-sdk-v5");
    const cos = new COS({
      getAuthorization: function (options, callback) {
        let token = getCookie('token');
        let baseUrl = "https://www.xxnotes.cn/api/";
        axios({
          method:'get',
          url: baseUrl + '/sys/config/cosConfig/toC?token=' + token
        }).then(function(res){
          let data1 = res.data.data;
          let credentials = data1 && data1.credentials;
          if (!data1 || !credentials) return console.error('credentials invalid');
          callback({
            TmpSecretId: credentials.tmpSecretId,
            TmpSecretKey: credentials.tmpSecretKey,
            XCosSecurityToken: credentials.sessionToken,
            StartTime: data1.startTime,
            ExpiredTime: data1.expiredTime,
          });
        })
      }
    });
    let random = Math.floor(Math.random() * 999999) +   "_" ;
    let fileName = random + resultFiles[0].name;
    cos.putObject(
      {
        Bucket: "mg-1303928515" /* 必须 */,
        Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
        Key: "richtext/video/" + fileName /* 必须 */,
        StorageClass: "STANDARD",
        Body: resultFiles[0], // 上传文件对象
      },
      (err, data) => {
        if (data && data.statusCode) {
          insertVideo("https://" + data.Location);
        }
      }
    );
  }
  function insertVideo(video) {
    editor.cmd.do(
      "insertHTML",
      `<video controls style="width: 100%" :disablePictureInPicture="true" controlsList="nodownload" src=${video}></video>` +
        "<p><br></p>"
    );
  }
  const conf = {
    width: 300,
    height: 0,

    // panel 中可包含多个 tab
    tabs: [
      {
        title: "上传视频",
        tpl:
          '<div class="w-e-up-img-container"><div id="' +
          upTriggerVideoId +
          '" class="w-e-up-btn"><i class="w-e-icon-upload2"></i></div><div style="display:none;"><input id="' +
          upFileVideoId +
          '" type="file" accept="video/*"/></div></div>',
        events: [
          {
            // 触发选择图片
            selector: "#" + upTriggerVideoId,
            type: "click",
            fn: function fn() {
              var $file = $("#" + upFileVideoId);
              var fileElem = $file.elems[0];
              if (fileElem) {
                fileElem.click();
              } else {
                // 返回 true 可关闭 panel
                return true;
              }
            },
          },
          {
            // 选择图片完毕
            selector: "#" + upFileVideoId,
            type: "change",
            fn: function fn() {
              var $file = $("#" + upFileVideoId);
              var fileElem = $file.elems[0];
              if (!fileElem) {
                // 返回 true 可关闭 panel
                return true;
              }

              // 获取选中的 file 对象列表
              var fileList = fileElem.files;
              if (fileList.length) {
                upLoadVide(fileList, insertVideo);
                // insertVideo(video);
              }

              // 返回 true 可关闭 panel
              return true;
            },
          },
        ],
      }, // first tab end
      {
        // tab 的标题
        title: editor.i18next.t("menus.panelMenus.video.插入视频"),
        // 模板
        tpl: `<div>
          <input
            id='${inputIFrameId}'
            type='text'
            class='block'
            placeholder='${editor.i18next.t("如")}：https://video.mp4'/>
          </td>
          <div class='w-e-button-container'>
            <button id='${btnOkId}' class='right'>
              ${editor.i18next.t("插入")}
            </button>
          </div>
        </div>`,
        // 事件绑定
        events: [
          {
            selector: "#" + btnOkId,
            type: "click",
            fn: () => {
              // 执行插入视频
              const $video = $("#" + inputIFrameId);
              let video = $video.val().trim();
              if (!video) return;
              insertVideo(video);
              return true;
            },
          },
        ],
      },
    ],
  };

  return conf;
}

class Video extends PanelMenu {
  constructor(editor) {
    const $elem = $(
      `<div class='w-e-menu'>
          <i class='w-e-icon-play'></i>
        </div>`
    );
    super($elem, editor);
  }

  /**
   * 菜单点击事件
   */
  clickHandler() {
    // 弹出 panel
    this.createPanel("");
  }

  /**
   * 创建 panel
   * @param link 链接
   */
  createPanel(iframe) {
    const conf = createPanelConf(this.editor, iframe);
    const panel = new Panel(this, conf);
    panel.create();
  }

  /**
   * 尝试修改菜单 active 状态
   */
  tryChangeActive() {}
}

export default {
  data() {
    return {
      id: "id" + new Date().getTime(),
      editor: null,
    };
  },
  props: {
    value: String,
    height: {
      type: Number,
      default: 300,
    },
  },
  mounted() {
    let editor = new E(`#${this.id}`);
    editor.config.menus = ["image", "video", "emoticon"];
    const menus = editor.config.menus;
    const index = menus.findIndex((i) => i === "video");
    editor.config.menus.splice(index, 1);
    editor.menus.extend("myVideo", Video);
    editor.config.menus = editor.config.menus.concat("myVideo");
    editor.config.showFullScreen = false;
    editor.config.customUploadImg = this.customUploadImg;
    // editor.config.onblur = this.onblur
    editor.config.onchange = this.onchange;
    editor.config.height = 200;

    editor.create();
    this.editor = editor;
    if (this.value) {
      editor.txt.html(this.value);
    }
  },
  methods: {
    // onblur(html) {
    //   this.$emit('blur', html)
    // },
    onchange(html) {
      this.$emit("change", html);
      this.$emit("input", html);
    },
    customUploadImg(resultFiles, insertImgFn) {
      const isLtxM = resultFiles[0].size / 1024 / 1024 < 2;
      if (!isLtxM){
        this.$Message.error('上传文件大小不能超过 2MB，请删除该文件，重新上传!');
        return
      }
      let random = Math.floor(Math.random() * 999999) +   "_" ;
      let fileName = random + resultFiles[0].name;
      const COS = require("cos-js-sdk-v5");
      let that = this;
      const cos = new COS({
        getAuthorization: function (options, callback) {
          that._r.get("/sys/config/cosConfig/toC")
                  .then((res) => {
                    let data = res.data;
                    debugger
                    let credentials = data && data.credentials;
                    if (!data || !credentials) return console.error('credentials invalid');
                    callback({
                      TmpSecretId: credentials.tmpSecretId,
                      TmpSecretKey: credentials.tmpSecretKey,
                      XCosSecurityToken: credentials.sessionToken,
                      StartTime: data.startTime,
                      ExpiredTime: data.expiredTime,
                    });
                  })
                  .catch(() => {
                    this.loading = false;
                  });
        }
      });
      cos.putObject(
        {
          Bucket: "mg-1303928515" /* 必须 */,
          Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
          Key: "richtext/image/" + fileName /* 必须 */,
          StorageClass: "STANDARD",
          Body: resultFiles[0], // 上传文件对象
        },
        (err, data) => {
          if (data && data.statusCode) {
            console.log("11" +  data.Location)
            insertImgFn("https://" + data.Location);
          }
        }
      );
    },
  },
  destroyed() {
    this.editor.destroy();
  },
};
</script>

<style lang='scss'>
</style>
